import { defineComponent as a, useAttrs as u, computed as r, withDirectives as d, createBlock as p, openBlock as h, mergeProps as m, withCtx as C, createTextVNode as f, toDisplayString as b, vShow as A } from "vue";
import g from "./Chip.js";
const N = /* @__PURE__ */ a({
  name: "ll-license-chip",
  inheritAttrs: !1,
  __name: "LicenseChip",
  props: {
    license: {},
    size: { default: "medium" },
    disabled: { type: Boolean }
  },
  setup(i) {
    const s = i, c = u(), o = r(() => {
      const e = { ...c };
      return delete e["color-scheme"], delete e.radius, delete e.shade, e;
    }), l = Object.freeze({
      MED: "yellow",
      MEDI: "yellow",
      REC: "blue",
      RECR: "blue",
      COM: "royal",
      COMB: "royal",
      ANC: "orange",
      ANCI: "orange",
      BUL: "ice",
      BULK: "ice",
      CAN: "green",
      CANN: "green",
      ADU: "blue",
      ADUL: "blue"
    }), n = r(() => s.disabled ? "ice" : t.value in l ? l[t.value] : "blue"), t = r(() => {
      const e = s.license.toUpperCase();
      return e.length > 4 ? e.slice(0, 3) : e;
    });
    return (e, v) => d((h(), p(g, m({
      class: "stash-license-chip",
      "data-test": "stash-license-chip",
      radius: "pill",
      shade: "main",
      "color-scheme": n.value,
      size: s.size
    }, o.value, { disabled: e.disabled }), {
      default: C(() => [
        f(b(t.value), 1)
      ]),
      _: 1
    }, 16, ["color-scheme", "size", "disabled"])), [
      [A, t.value.length]
    ]);
  }
});
export {
  N as default
};
//# sourceMappingURL=LicenseChip.js.map
